/* Novelys NFC — petits branchements de page, charges par l'en-tete donc
   presents partout.

   1. La rotation des messages de la bande d'informations.
   2. L'ancre #nv-avis, vers laquelle la note de la fiche produit renvoie.
   3. La lecture automatique en boucle des videos marquees `data-nv-auto`.

   Pourquoi du JavaScript pour la rotation plutot que des keyframes CSS : le
   nombre de messages est reglable dans l'editeur de theme (de un a cinq). Des
   keyframes exigeraient des pourcentages calcules sur ce nombre, donc une
   feuille generee a chaque rendu. Vingt lignes de script sont plus simples.

   Sans ce fichier la bande reste lisible : le CSS affiche le premier message
   par defaut. Le script ne fait qu'ajouter la rotation. */
(function () {
  'use strict';
  if (window.__nvBarReady) return;
  window.__nvBarReady = true;

  var doux = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function demarrer(bar) {
    if (bar.dataset.nvReady === '1') return;
    bar.dataset.nvReady = '1';

    var items = bar.querySelectorAll('.nv-bar__set > li');
    /* Un seul message : rien a faire tourner, on laisse le CSS l'afficher. */
    if (items.length < 2) return;

    var duree = parseInt(bar.getAttribute('data-nv-duree'), 10) || 5000;
    var i = 0;
    var pause = false;

    bar.classList.add('is-live');
    items[0].classList.add('is-on');

    function suivant() {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }

    function tic() {
      setTimeout(function () {
        /* On ne fait pas defiler dans un onglet cache : personne ne regarde, et
           les minuteries y sont de toute facon bridees par le navigateur. */
        if (!pause && !document.hidden) suivant();
        tic();
      }, duree);
    }

    /* Quelqu'un survole ou tabule dans la bande : il lit. On attend. */
    bar.addEventListener('mouseenter', function () { pause = true; });
    bar.addEventListener('mouseleave', function () { pause = false; });
    bar.addEventListener('focusin', function () { pause = true; });
    bar.addEventListener('focusout', function () { pause = false; });

    tic();
  }

  /* La note de la fiche produit renvoie vers #nv-avis. Le bloc d'avis est une
     section distincte dont l'identifiant est genere par Shopify (il contient
     l'identifiant du gabarit), donc impossible a ecrire en dur dans la fiche.
     On pose l'ancre sur le bloc lui-meme, pas sur l'enveloppe de section :
     l'editeur de theme se sert de l'identifiant de l'enveloppe pour cibler ses
     sections, l'ecraser casserait l'apercu. */
  function ancre() {
    var rev = document.querySelector('.nv-rev');
    if (rev && !rev.id && !document.getElementById('nv-avis')) rev.id = 'nv-avis';
  }

  /* Videos en lecture automatique, facon image animee : muettes, en boucle,
     sans commandes. Deux precautions :
     - `preload="none"` dans le markup + lecture au moment ou la video entre
       dans l'ecran : le fichier n'est telecharge que si le visiteur descend
       jusque-la. Sur un forfait mobile, ca change tout ;
     - si le visiteur a demande moins d'animations, on ne lance rien et on lui
       rend les commandes. Une video qui demarre seule est exactement ce que ce
       reglage existe pour eviter. */
  function videos() {
    var vs = document.querySelectorAll('video[data-nv-auto]');
    if (!vs.length) return;

    if (doux) {
      vs.forEach(function (v) { v.controls = true; v.preload = 'metadata'; });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      vs.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }

    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) e.target.play().catch(function () {});
        else e.target.pause();
      });
    }, { threshold: 0.25 });

    vs.forEach(function (v) { io.observe(v); });
  }

  function boot() {
    document.querySelectorAll('.nv-bar').forEach(demarrer);
    ancre();
    videos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
